import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, Text as FluentText } from '@bingads-webui-react/fabric-control';

const style = mergeStyles({
  lineHeight: 19,
});

export const Data = ({ data, ...rest }) => <FluentText className={style} {...rest}>{data}</FluentText>;

Data.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};
